<template>
  <div v-if="incomingCall" class="icm-overlay">
    <div class="icm-card">
      <div class="icm-caller">
        <v-avatar :size="64" color="#e5e5ea" class="icm-avatar">
          <v-img v-if="incomingCall.caller_avatar" :src="incomingCall.caller_avatar" />
          <v-icon v-else color="#8e8e93" size="28">mdi-account</v-icon>
        </v-avatar>
        <div class="icm-name">{{ incomingCall.caller_name }}</div>
        <div class="icm-type">
          Incoming {{ incomingCall.call_type === 'video' ? 'video' : 'voice' }} call...
        </div>
      </div>
      <div class="icm-actions">
        <button class="icm-btn icm-btn-decline" @click="onDecline" title="Decline">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round">
            <path d="M10.68 13.31a16 16 0 0 0 3.41 2.6l1.1-1.1a2 2 0 0 1 2.11-.45 11.5 11.5 0 0 0 3.59.59 2 2 0 0 1 2 2v3a2 2 0 0 1-2.18 2A19.79 19.79 0 0 1 2.18 3.18 2 2 0 0 1 4 1h3.09a2 2 0 0 1 2 1.72 11.5 11.5 0 0 0 .59 3.59 2 2 0 0 1-.45 2.11z"/>
            <line x1="1" y1="1" x2="23" y2="23"/>
          </svg>
        </button>
        <button class="icm-btn icm-btn-accept" @click="onAccept" title="Accept">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round">
            <path d="M15.05 5A5 5 0 0 1 19 8.95M15.05 1A9 9 0 0 1 23 8.94m-1 7.98v3a2 2 0 0 1-2.18 2A19.79 19.79 0 0 1 2.18 3.18 2 2 0 0 1 4 1h3.09a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 8.91a16 16 0 0 0 7 7l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 23 16.92z"/>
          </svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'IncomingCallModal',
  computed: {
    ...mapState('Call', ['incomingCall']),
  },
  methods: {
    ...mapActions('Call', ['answerCall', 'declineCall']),
    onAccept() {
      if (!this.incomingCall) return;
      this.answerCall({ callId: this.incomingCall.call_id });
    },
    onDecline() {
      if (!this.incomingCall) return;
      this.declineCall({ callId: this.incomingCall.call_id });
    },
  },
};
</script>

<style lang="scss" scoped>
.icm-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
}

.icm-card {
  background: #1c1c1e;
  border-radius: 20px;
  padding: 36px 32px 28px;
  min-width: 280px;
  max-width: 340px;
  text-align: center;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);
}

.icm-caller {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin-bottom: 32px;
}

.icm-avatar {
  border: 2px solid rgba(255, 255, 255, 0.15);
}

.icm-name {
  font-size: 20px;
  font-weight: 600;
  color: #fff;
  letter-spacing: -0.3px;
}

.icm-type {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
}

.icm-actions {
  display: flex;
  justify-content: center;
  gap: 48px;
}

.icm-btn {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: transform 0.15s;
  &:hover { transform: scale(1.08); }
  &:active { transform: scale(0.95); }
}

.icm-btn-decline {
  background: #ff3b30;
}

.icm-btn-accept {
  background: #34c759;
}
</style>
